@if (innerWidth < 427) {
<div
  class="container"
  style="height: 57rem"
  style="padding-left: 0px !important"
>
  <div class="row justify-content-center pag-portada bg-white">
    <div class="col-sm-10 align-self-center text-center">
      <img
        [src]="objeto.frontPageUrl"
        class="h-27r"
        alt=""
        style="height: 55rem !important"
      />
    </div>
  </div>
</div>
} @if (innerWidth > 426) {
<div class="container" style="height: 57rem">
  <div class="row justify-content-center pag-portada bg-white">
    <div class="col-sm-10 align-self-center text-center">
      <img
        [src]="objeto.frontPageUrl"
        class="h-27r"
        alt=""
        style="height: 55rem !important"
      />
    </div>
  </div>
</div>
}
